<template lang="pug">
  div(style="margin-top:12px; margin-bottom:-16px").group-horizontal.area
    el-col(:span="10" style="margin-right:200px; ")
      el-radio(:label="label", v-model="radio", @change="changeRadio")
        slot
    el-col(v-if="showInput", :span="14")
      el-form-item(:prop="prop", :rules="rule", ref="formItem")
        el-input(
          :disabled="isDisable",
          v-model.number="input",
          :placeholder="placeHolder",
          @change="changeInput",
          style="top: -10px; width:65px;",
          maxlength= 3,
        )
    span(v-if="showInput", style="color: #606266; margin-left:10px;") /
    el-col(v-if="showInput", :span="14")
      el-form-item(:prop="secondProp", :rules="rule", ref="formItem")
        el-input(
          :disabled="isDisable",
          v-model.number="secondInput",
          :placeholder="secondPlaceHolder",
          @change="changeInput",
          style="top: -10px; margin-left:8px; width:65px;",
          maxlength= 2,
        )
    el-col(v-else, :span="14")
      .trailing
</template>

<style lang="scss" scoped>
.row {
  display: flex;
  justify-content: space-between;
}
.text {
  color: #606266;
  font-size: 18px;
  font-weight: 400;
  line-height: 2.2;
}
.radio {
  margin-top: 12px;
  margin-left: 0px;
  font-size: 16px;
}

.group-horizontal {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  &.input-checkbox {
    margin-bottom: 10px;
    width: 400px;
    &.extended {
      width: 600px;
    }
  }
  &.radio-input {
    margin-top: 5px;
    height: 30px;
  }
  &.area {
    width: 400px;
    height: 50px;
  }
}

.trailing {
  margin-left: 10px;
  font-size: 18px;
  color: #606266;
}
</style>

<script>
export default {
  name: 'radioClass',
  props: {
    radioValue: [String, Number, Boolean],
    inputValue: [Number],
    secondInputValue: [Number],
    placeHolder: [String],
    secondPlaceHolder: [String],
    label: {
      type: String,
      required: true,
    },
    showInput: {
      type: Boolean,
      default: false,
      required: false,
    },
    isCGN: {
      type: Boolean,
      default: false,
      required: false,
    },
    prop: {
      type: String,
      required: false,
    },
    secondProp: {
      type: String,
      required: false,
    },
  },
  data () {
    return {
      input: 0,
      secondInput: 0,
      radio: '',
      isDisable: false,
      isCGN: false,
      rule: [ { required: true, type: 'number', min: 0, message: `กรุณากรอก ตัวเลขรุ่น/YY`, trigger: 'blur' } ],
    }
  },
  watch: {
    radioValue (val, oldVal) {
      if (this.isCGN) {
        this.showInput = true
        if (val !== this.label) {
          this.$refs.formItem.clearValidate()
        }
      } else if (!this.isCGN) {
        this.isDisable = false
        if (val !== this.label) {
          this.showInput = false
          this.$refs.formItem.clearValidate()
        } else {
          this.showInput = true
        }
      }
      this.radio = this.label
    },
    inputValue (val, oldVal) {
      if (this.isDisable) {
        this.input = oldVal
      }
      this.input = val
    },
    secondInputValue (val, oldVal) {
      if (this.isDisable) {
        this.secondInput = oldVal
      }
      this.secondInput = val
    },
  },
  methods: {
    changeInput (value) {
      this.$emit('update:inputValue', this.input)
      this.$emit('update:secondInputValue', this.secondInput)
    },
    changeRadio (value) {
      this.$emit('update:inputValue', this.input)
      this.$emit('update:secondInputValue', this.secondInput)
      this.$emit('update:radioValue', this.label)
    },
  },
}
</script>
